<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-06-40"></menubar>
    </div>
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">
          {{ $t("label.system.userGroup.search.title") }}
        </label>
        <lvory-but
          @click="back"
          slot="cancel">
            {{ $t("button.common.data.cancel") }}
        </lvory-but>
        <narrow-down
          v-auth="{ auth: '010702' }"
          slot="create"
          @click="editUserGroup">
          {{$t("button.common.data.create")}}
        </narrow-down>
      </head-title>
    </el-row>
    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.system.userGroup.edit.userGroupEdit") }}
      </div>
      <el-row>
        <span class="star-color">* </span>
        <span class="c-ivory01">{{ $t("label.common.must") }}</span>
      </el-row>

      <el-form
        ref="ruleForm"
        class="account-create"
        label-position="left"
        :rules="rules"
        :model="userGroupInfo">
        <div class="info-margin-top">
            <!-- ユーザーグループID -->
            <el-form-item
                class="asterisk line-height-44"
                :label="$t('label.system.userGroup.search.userGroupID')"
                label-width="200px">
                <span class="word-type">
                    {{ userGroupInfo.userGroupExId }}
                </span>
            </el-form-item>
            <!-- ユーザーグループ名 -->
            <el-form-item
                prop="userGroupName"
                class="asterisk line-height-44"
                :label="$t('label.system.userGroup.search.userGroupName')"
                label-width="200px">
                <el-input
                maxlength="50"
                class="new-input-style show-word-limt-input-iot"
                show-word-limit
                v-model="userGroupInfo.userGroupName"
                :placeholder="$t('label.system.userGroup.search.userGroupName')">
                </el-input>
            </el-form-item>
            <!-- テナント -->
            <el-form-item
                class="asterisk line-height-44"
                :label="$t('label.system.userGroup.create.tenant')"
                label-width="200px">
                <span class="word-type">
                    {{ userGroupInfo.tenantName }}
                </span>
            </el-form-item>

            <!--  エリア情報  -->
            <div class="area-info-type">
                <el-form-item
                    label-width="200px"
                    :label="$t('label.system.userGroup.detail.areaInfo')">
                    <div v-for="(item,index) in userGroupInfo.areaList" :key="index" class="span-wrap-size-color text-word-break">
                        {{ item.buildingName + ' ' + item.floorName + ' ' + item.areaName }}
                    </div>
                </el-form-item>
            </div>
        </div>

      </el-form>

      <hr class="delimiter margin-top-0" />

      <div class="main-title">
        {{ $t("label.system.userGroup.detail.memberInfo") }}
      </div>

      <el-table
        class="m-top-5 table-header-th-top-0"
        style="width: 100% !important"
        header-cell-class-name="sp-table-cell"
        :data="userGroupInfo.accountList">
        <!--  メンバー名  -->
        <el-table-column
          class-name="col-2"
          prop="fullname"
          :label="$t('label.system.userGroup.detail.memberName')"/>

        <!--  メールアドレス  -->
        <el-table-column
          class-name="col-8"
          prop="email"
          :label="$t('label.system.userGroup.detail.emailAddress')"/>
      </el-table>

      <loading-dialog :dialogVisible="showLoading" />

      <!-- テナント選択子画面 -->
      <tenant-search-popup
        :visible.sync="tenantSearchFlg"
        :includeDeleteDataFlag = false
        @on-selected="getTenantInfo"/>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>
    </div>

  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import MainLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import TenantSearchPopup from "@/components/system/popup/TenantSearchPopup";
import Menubar from "@/components/leftmenu/DashBoard";
import headTitle from "@/components/common/head/head";
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import errorCodeMsg from "@/utils/error-code-msg"

export default {
  name: "AccountCreate",
  components: {
    MainLayout: MainLayout,
    TenantSearchPopup: TenantSearchPopup,
    LoadingDialog: LoadingDialog,
    Menubar: Menubar,
    headTitle: headTitle,
    narrowDown: narrowDown,
    elDialogPrompt: elDialogPrompt,
    LvoryBut:LvoryBut,
  },
  data() {
    //発行日終了時間の確認
    return {
      userGroupInfo:{
        userGroupExID:null,
        userGroupName:null,
        tenantId:null,
        tenantExId:null,
        tenantName:null
      },
      showLoading:false,
      tenantSearchFlg:false,
      msgParam: this.$t("message.common.validation.saveMessage",{
        field: this.$t("label.menu.UserGroup")
      }),
      centerDialogVisibleIsShow: false,
      userGroupId: null,
      rules:{
        userGroupName: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.userGroup.search.userGroupName')
            })
          },
          {
            max: 50,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t('label.system.userGroup.search.userGroupName'),
              length: 50
            })
          }
        ]
      },
    };
  },
  watch: {

  },
  created() {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/user-group/search",
        title: "label.menu.UserGroup",
      },
      {
        path: "",
        title: "label.menu.userGroupCreate",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    if (this.$IsOwnerManager()) {
      this.accountType= [
        {
          value: "02",
          type: this.$t("label.system.account.accountType.BM"),
        },
        {
          value: "04",
          type: this.$t("label.system.account.accountType.tenant"),
        }
      ];
    }
    this.userGroupId = this.$route.params.userGroupId;
    this.initializationData()
  },
  methods: {

    back() {
      this.$router.push({
        name: "system-user-group-detail",
        params: {
          userGroupId: this.userGroupId,
        },
      });
    },
    initializationData() {
        this.showLoading = true
        SystemManageApi.detailUserGroup(this.userGroupId)
          .catch((error) => {
          errorCodeMsg(error, this)
          })
          .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
              this.showLoading = false
              return;
          }
          this.userGroupInfo = data.body
          }).finally(()=>{
          this.showLoading = false
          })
    },

    /**
     *  テナント選択 スプライト
     */
    searchTenantPopup() {
      this.tenantSearchFlg = true;
    },

    /**
     *  テナント選択 スプライト
     */
    getTenantInfo(tenant) {
      this.userGroupInfo.tenantId = tenant.tenantId;
      this.userGroupInfo.tenantExId = tenant.tenantExId;
      this.userGroupInfo.tenantName = tenant.tenantName;
    },


    isPassParam(param){
      if(param){
        this.doneEditUserGroup();
      }
    },

    /**
     * アカウント新規登録
     */
    editUserGroup() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
        }
      });
    },

    /**
     * アカウント新規登録
     */
    doneEditUserGroup() {
      this.showLoading = true;
      SystemManageApi.updateUserGroup({
        userGroupId: this.userGroupId,
        userGroupName:this.userGroupInfo.userGroupName
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.saveSuccess();
          this.$router.push({
            name: "system-user-group-detail",
            params: {
              userGroupId: this.userGroupId,
            },
          });
        }).finally(()=>{
          this.showLoading = false
        })
    },

    /**
     *
     */
    saveSuccess() {
      this.$messageIotSuccess(this.$t("message.common.updateSuccess", {
        field: this.$t("label.system.userGroup.search.title"),
      }));
    },

  }
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}

::v-deep .new-input-style {
  .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
.star-color {
  color: #e65245
}

.info-margin-top {
  margin-top: 40px;
}

.hr {
  height: 1px;
  width: 800px;
  background-color: #D1D1CD;
}
::v-deep .el-form-item__label:before {
  display: none;
}
::v-deep .asterisk {
  .el-form-item__label {
    font-size: 16px !important;
  }
  .el-form-item__label::after{
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
::v-deep .el-form-item__error {
  width: 800px;
  padding-top: 6px;
}

::v-deep .el-form-item {
  margin-bottom: 40px !important;
}

::v-deep .el-row--flex.is-align-middle {
  align-items: normal;
}


.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}

.account-create::v-deep {
  .el-form-item__label {
    font-size: 16px;
  }
}

.area-info-type {
    display: flex;
}

.span-wrap-size-color {
  color: #525250;
}

.word-type {
  font-size: 14px;
  color: #525250;
}

/* No.129 */
hr.delimiter {
  margin-top:40px;
  margin-bottom: 40px;
  background-color: #d1d1cd;
}

.margin-top-0 {
  margin-top: 0px !important;
}
</style>
